/**
 * Human-readable age from date of birth (same logic as Edit Client basic info).
 * @param {string|Date|null|undefined} dateOfBirth - ISO date or YYYY-MM-DD
 * @returns {string|null} e.g. "26 months", "1 month", or null if unknown
 */
export function ageInMonthsDisplay(dateOfBirth) {
  if (dateOfBirth == null || dateOfBirth === '') return null;
  const raw = typeof dateOfBirth === 'string' ? dateOfBirth.split('T')[0].trim() : '';
  if (!raw) return null;
  const dob = new Date(raw);
  if (Number.isNaN(dob.getTime())) return null;
  const today = new Date();
  let months = (today.getFullYear() - dob.getFullYear()) * 12 + (today.getMonth() - dob.getMonth());
  if (today.getDate() < dob.getDate()) months -= 1;
  if (months < 0) return null;
  return months === 1 ? '1 month' : `${months} months`;
}
